import { Model, View } from '@lernetz/ts-lib';

import template from './CollapsibleSection.html';
import level3HeaderTemplate from './Level3Header.html';
import level4HeaderTemplate from './Level4Header.html';

export class CollapsibleSection extends Model {

    public readonly level: number;
    public readonly title: string;
    public readonly elements: object[];
    public readonly marginTop: string;
    public readonly marginBottom: string;

    public collapsed: boolean;
    public height: number;

    public constructor(dto) {
        super({ marginTop: '', marginBottom: '', ...dto });

        this.collapsed = dto.initiallyCollapsed;
        this.height = 0;
        this.level = Number(dto.level || 3);
    }
}

export class CollapsibleSectionView extends View<CollapsibleSection> {

    public constructor() {
        super({ template });

        this.registry.add(3, () => new View({ template: level3HeaderTemplate }));
        this.registry.add(4, () => new View({ template: level4HeaderTemplate }));
    }

    init() {
        this.data.propertyChange.filter(({ name }) => name === 'collapsed')
                                .subscribe(this.onCollapsedChanged.bind(this));
        this.resetHeight();

        const itemsNode = this.getItemsNode();
        itemsNode.addEventListener('animationend', this.resetHeight.bind(this));
        itemsNode.addEventListener('transitionend', this.resetHeight.bind(this));
    }

    private getItemsNode(): HTMLElement {
        return this.node.querySelector('.collapse-box > .content');
    }

    private onCollapsedChanged() {
        const itemsNode = this.getItemsNode();

        if (!itemsNode.style.height) {
            const oldHeight = this.data.collapsed ? itemsNode.scrollHeight : 0;
            itemsNode.style.height = `${oldHeight}px`;
            setTimeout(this.onCollapsedChanged.bind(this), 25);
            return;
        }

        const newHeight = this.data.collapsed ? 0 : itemsNode.scrollHeight;
        itemsNode.style.height = `${newHeight}px`;
    }

    private resetHeight() {
        const itemsNode = this.getItemsNode();
        itemsNode.style.height = this.data.collapsed ? '0px' : '';
    }
}
